import * as React from "react"
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

// styles
const pageStyles = {
  color: "#232129",
  padding: 60,
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
}
const headingStyles = {
  marginTop: 0,
  // marginBottom: 64,
  maxWidth: 320,
}
const paragraphStyles = {
  marginBottom: 48,
}
const listStyles = {
  marginBottom: 96,
  paddingLeft: 0,
}
const listItemStyles = {
  fontWeight: 300,
  fontSize: 24,
  maxWidth: 560,
  marginBottom: 30,
}
const descriptionStyle = {
  color: "#232129",
  fontSize: 14,
  marginTop: 10,
  marginBottom: 0,
  lineHeight: 1.25,
  wordBreak: "break-word"
}
const badgeStyle = {
  color: "#fff",
  backgroundColor: "#088413",
  border: "1px solid #088413",
  fontSize: 11,
  fontWeight: "bold",
  letterSpacing: 1,
  borderRadius: 4,
  padding: "4px 6px",
  display: "inline-block",
  position: "relative",
  top: -2,
  marginLeft: 10,
  lineHeight: 1,
}
const iconStyles = {
  width: "100px"
}

// data
const links = [
  {
    id: 0,
    text: "About and Copyright",
    description:
    "Quick and easy open-string tuning for the violin, viola, cello, double bass, guitar, ukulele, bass and mandolin. Perfect for on-the-go hobbyists and small ensembles. Standard tuning notes are used.",
    additional:
      "The String Tuner iOS app is a free app which you can download from the App Store. All rights reserved for both the String Tuner iOS app and this website alongside their content. ©2022 Lu Cui",
    color: "#5AAAE1",
  },
  {
    id: 1,
    text: "Privacy Policy (String Tuner iOS app)",
    description:
      "The iOS app does not collect any personal information. However, Google Admob is used to serve personalised in-app advertisements. Find out more on https://support.google.com/admob/answer/2753860#Interest_based. You can turn off personalised ads at any time from Settings > Privacy > Apple Advertising. Find out more on https://support.apple.com/en-us/HT202074.",
    additional:
      "General location data (e.g., country) and data about your device (e.g., model and version) are automatically collected. Data about your use of the service, such as typical interactions within the app, will not be collected.",
    color: "#5AAAE1",
  },
]

const getSoundNameFromMapping = (title) => {

  let mapped = "g3";
  switch (title) {
      case "dbass-e":
      case "bass-e":
          mapped = "e1"
          break
      case "dbass-a":
      case "bass-a":
          mapped = "a1"
          break
      case "dbass-d":
      case "bass-d":
          mapped = "d2"
          break
      case "guitar-e":
          mapped = "e2"
          break
      case "dbass-g":
      case "bass-g":
          mapped = "g2"
          break
      case "guitar-a":
          mapped = "a2"
          break
      case "cello-c":
          mapped = "c2"
          break
      case "cello-g":
          mapped = "g2"
          break
      case "cello-d":
      case "guitar-d":
          mapped = "d3"
          break
      case "viola-c":
          mapped = "c3"
          break
      case "violin-g":
      case "mandolin-g":
      case "viola-g":
      case "guitar-g":
          mapped = "g3"
          break
      case "cello-a":
          mapped = "a3"
          break
      case "guitar-b":
          mapped = "b3"
          break
      case "ukulele-c":
          mapped = "c4"
          break
      case "violin-d":
      case "mandolin-d":
      case "viola-d":
          mapped = "d4"
          break
      case "guitar-higher-e":
      case "ukulele-e":
          mapped = "e4"
          break
      case "ukulele-g":
          mapped = "g4"
          break
      case "violin-a":
      case "mandolin-a":
      case "viola-a":
      case "ukulele-a":
          mapped = "a4"
          break
      case "violin-e":
      case "mandolin-e":
          mapped = "e5"
          break
      default:
          break
  }
  return mapped;
}

// title is 'violin-e', mapped is g5, soundName=/path/to/g5.m4a
const Player = ({ title }) => {

  const soundUrl = `/static/sounds/${getSoundNameFromMapping(title)}.m4a`;
  const soundName = title.slice(-1).toUpperCase();
  return (
    <React.Fragment>
      <h3>{ soundName }</h3>
      <AudioPlayer
        src={soundUrl}
        onPlay={e => console.log("onPlay")}
        // other props here
      />
    </React.Fragment>
  )
}

// markup
const IndexPage = () => {
  return (
    <main style={pageStyles}>
      <title>Home Page</title>
      <h1 style={headingStyles}>
      String Tuner
      </h1>
      <img
        alt="String Tuner Logo"
        src="/static/appicon.jpg"
        style={iconStyles}
      />
      <ul style={listStyles}>
        {links.map(link => (
          <li key={link.id} style={{ ...listItemStyles, color: link.color }}>
            <span>
              {link.text}
              {link.badge && (
                <span style={badgeStyle} aria-label="New Badge">
                  NEW!
                </span>
              )}
              <p style={descriptionStyle}>{link.description}</p>
              <p style={descriptionStyle}>{link.additional}</p>
            </span>
          </li>
        ))}
      </ul>

      <a target="_blank" href="https://apps.apple.com/app/id1638424553?platform=iphone"><img
        alt="App Store Logo"
        src="/static/appstore-badge.png"
        style={iconStyles}
      /></a>

      <h2>Violin</h2>
      <Player title="violin-g"></Player>
      <Player title="violin-d"></Player>
      <Player title="violin-a"></Player>
      <Player title="violin-e"></Player>
      <hr />
      <h2>Viola</h2>
      <Player title="viola-c"></Player>
      <Player title="viola-g"></Player>
      <Player title="viola-d"></Player>
      <Player title="viola-a"></Player>
      <hr />
      <h2>Cello</h2>
      <Player title="cello-c"></Player>
      <Player title="cello-g"></Player>
      <Player title="cello-d"></Player>
      <Player title="cello-a"></Player>
      <hr />
      <h2>Double Bass</h2>
      <Player title="dbass-e"></Player>
      <Player title="dbass-a"></Player>
      <Player title="dbass-d"></Player>
      <Player title="dbass-g"></Player>
      <hr />


      <h2>Guitar</h2>
      <Player title="guitar-e"></Player>
      <Player title="guitar-a"></Player>
      <Player title="guitar-d"></Player>
      <Player title="guitar-g"></Player>
      <Player title="guitar-b"></Player>
      <Player title="guitar-higher-e"></Player>
      <hr />
      <h2>Ukulele</h2>
      <Player title="ukulele-g"></Player>
      <Player title="ukulele-c"></Player>
      <Player title="ukulele-e"></Player>
      <Player title="ukulele-a"></Player>
      <hr />
      <h2>Bass</h2>
      <Player title="bass-e"></Player>
      <Player title="bass-a"></Player>
      <Player title="bass-d"></Player>
      <Player title="bass-g"></Player>
      <hr />
      <h2>Mandolin</h2>
      <Player title="mandolin-g"></Player>
      <Player title="mandolin-d"></Player>
      <Player title="mandolin-a"></Player>
      <Player title="mandolin-e"></Player>

    </main>
  )
}

export default IndexPage
